<section class="w-full h-[180px] flex flex-wrap rounded-lg p-4">
  <header class="w-full flex flex-wrap">
    <p
      class="text-lg md:text-xl font-medium text-gray-900 w-full text-center border-b border-gray-100 dark:border-gray-600"
    >
      خروج از حساب کاربری
    </p>

    <p class="text-sm md:text-base pt-4 text-gray-900">
      آیا می‌خواهید از حساب کاربری خود خارج شوید؟
    </p>
  </header>

  <main class="w-full flex">
    <div class="w-full pr-2 flex items-center">
      <button class="w-1/2 text-center h-10 ml-1 btn-green-flat" (click)="dismiss()">
        انصراف
      </button>
      <button
        class="w-1/2 text-center btn-red-outline mr-1 !rounded-md"
        (click)="logout()"
      >
        خروج
      </button>
    </div>
  </main>
</section>

<!-- to do: check exit dialog size in ts -->
